import { ArrowLeft } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import type { AdminUserDetailsResponseDTO } from '@/api/generated/model';
import { userStatusDisplay } from '../types';

/** Hero banner: background image, back button, avatar, displayName / @uName + status badge. */
export function UserHero({
  user,
  onBack,
}: {
  user: AdminUserDetailsResponseDTO;
  onBack: () => void;
}) {
  const status = userStatusDisplay(user.userStatus, user.deactivatedAt);
  return (
    <div className="relative overflow-hidden rounded-xl border">
      {/* background image (placeholder block when missing) */}
      <div
        className="h-40 w-full bg-muted"
        style={
          user.backgroundImage
            ? { backgroundImage: `url(${user.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }
            : undefined
        }
      />
      <Button
        variant="secondary"
        size="icon"
        className="absolute left-4 top-4"
        onClick={onBack}
        aria-label="Back"
      >
        <ArrowLeft />
      </Button>

      <div className="flex items-end gap-4 px-6 pb-4">
        <Avatar className="-mt-10 h-20 w-20 border-4 border-background">
          {user.avatarImage && <AvatarImage src={user.avatarImage} alt={user.displayName ?? ''} />}
          <AvatarFallback>{(user.displayName ?? user.uName ?? 'U').charAt(0).toUpperCase()}</AvatarFallback>
        </Avatar>
        <div className="flex flex-1 items-center justify-between pb-1">
          <div>
            <h1 className="text-xl font-semibold">{user.displayName ?? '—'}</h1>
            {user.uName && <p className="text-sm text-muted-foreground">@{user.uName}</p>}
          </div>
          <Badge variant={status.variant}>{status.label}</Badge>
        </div>
      </div>
    </div>
  );
}
